import type { IDashboardTemplate } from "../types";
import { EFamilyTypes } from "../components/DashboardTemplatesTypes";
import { AssetsService } from "../../../../services/AssetsService";
import { i18nFilter } from "../../../../filters/i18nFilter";
import {
    SEGMENTS_COMPARISON_METRICS,
    SEGMENTS_FAMILY_NAME,
} from "app/components/widget/widget-utilities/segments/constants";
import { DEFAULT_DURATION_FOR_SEGMENTS } from "app/components/widget/widget-config/metrics/segments/utils";

const i18n = i18nFilter();

const segmentAnalysisGroupTemplateConfig: IDashboardTemplate = {
    id: 15,
    title: "dashboard.templates.segmentAnalysis.group.title",
    description: "dashboard.templates.segmentAnalysis.group.description",
    descriptionLong: "dashboard.templates.segmentAnalysis.description.long",
    keyMetrics: "dashboard.templates.segmentAnalysis.keymetric",
    previewImage: AssetsService.assetUrl("/images/dashboard/templates/SegmentsGroupTemplate-preview.png"),
    thumbnailImage: AssetsService.assetUrl("/images/dashboard/templates/SegmentsGroupTemplate-thumb.png"),
    familyType: EFamilyTypes.Segments,
    minItems: 2,
    maxItems: 7,
    isNew: true,
    isSegmentsGroup: true,
    widgets: [
        {
            singleModeOnly: false,
            pos: {
                sizeX: 4,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 0,
                col: 0,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: SEGMENTS_COMPARISON_METRICS.Visits.name,
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: SEGMENTS_COMPARISON_METRICS.Visits.type,
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                title: i18n("dashboards.wizard.segments.monthlyVisits.title"),
            },
        },
        {
            singleModeOnly: false,
            pos: {
                sizeX: 4,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 1,
                col: 0,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: SEGMENTS_COMPARISON_METRICS.SegmentShare.name,
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: SEGMENTS_COMPARISON_METRICS.SegmentShare.type,
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                title: i18n("segments.group.analysis.tab.trafficshare.title"),
            },
        },
        {
            singleModeOnly: false,
            pos: {
                sizeX: 4,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 2,
                col: 0,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: SEGMENTS_COMPARISON_METRICS.UniqueUsers.name,
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: SEGMENTS_COMPARISON_METRICS.UniqueUsers.type,
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                title: i18n("folderanalysis.tabs.unique"),
            },
        },
        {
            singleModeOnly: false,
            pos: {
                sizeX: 4,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 3,
                col: 0,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: SEGMENTS_COMPARISON_METRICS.PagesViews.name,
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: SEGMENTS_COMPARISON_METRICS.PagesViews.type,
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                title: i18n("folderanalysis.tabs.pageviews"),
            },
        },
        {
            singleModeOnly: false,
            pos: {
                sizeX: 4,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 4,
                col: 0,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: SEGMENTS_COMPARISON_METRICS.PagePerVisit.name,
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: SEGMENTS_COMPARISON_METRICS.PagePerVisit.type,
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                title: i18n("folderanalysis.tabs.pagespervisit"),
            },
        },
        {
            singleModeOnly: false,
            pos: {
                sizeX: 4,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 5,
                col: 0,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: SEGMENTS_COMPARISON_METRICS.VisitDuration.name,
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: SEGMENTS_COMPARISON_METRICS.VisitDuration.type,
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                title: i18n("folderanalysis.tabs.duration"),
            },
        },
        {
            singleModeOnly: false,
            pos: {
                sizeX: 4,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 6,
                col: 0,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: SEGMENTS_COMPARISON_METRICS.BounceRate.name,
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: SEGMENTS_COMPARISON_METRICS.BounceRate.type,
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                title: i18n("folderanalysis.tabs.bounce"),
            },
        },
    ],
};

export default segmentAnalysisGroupTemplateConfig;
